"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTaskReviewProgress = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledTaskReviewProgress = styled_components_1.default.div `
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  min-width: 200px;

  .progress-dot {
    width: 8px;
    height: 8px;
    min-width: 8px;
    border-radius: 50%;
    background-color: ${ui_components_1.baseColors.primaryBlueMed400};

    &.complete {
      background-color: ${ui_components_1.baseColors.primaryGreen300};
    }
  }

  .progress-label {
    white-space: nowrap;
    color: ${({ theme }) => theme.palette.text.secondary};
  }

  .progress-value {
    white-space: nowrap;
    font-weight: 600;
    margin-left: auto;
  }

  .progress-bar {
    flex: 0 0 100%;
    border-radius: 4px;
    height: 4px;

    .MuiLinearProgress-bar {
      background-color: ${ui_components_1.baseColors.primaryGreen300};
    }

    &.loading .MuiLinearProgress-bar {
      background-color: ${ui_components_1.baseColors.primaryGreen300};
    }

    &.complete .MuiLinearProgress-bar {
      background-color: ${ui_components_1.baseColors.primaryGreen300};
    }
  }
`;
